import { useStyles } from "./IssueNumberCell.styles";
import IssueIcon from "pages/Corporate/RCA/images/issue_icon.svg";
import { useTranslation } from "react-i18next";
import { IIssueNumberCell } from "./IssueNumberCellInterfaces";

const IssueNumberCell = ({ issue }: IIssueNumberCell) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={classes.descriptionWrapper}>
            <img src={IssueIcon} alt="Issue icon" />
            <span>{`${t("rca.iss")}-${issue.issue_id}`}</span>
        </div>
    );
};

export default IssueNumberCell;
